import { NavLink } from "react-router-dom";

import { AppLogo } from "@/components/navigation/app-logo";
import { navigationSections } from "@/lib/navigation";
import { cn } from "@/lib/utils";

export function Sidebar() {
  return (
    <aside
      className={cn(
        "hidden border-r border-border/70 bg-card/85 px-3 py-5 backdrop-blur lg:flex lg:min-h-screen lg:w-[292px] lg:flex-col",
      )}
    >
      <div className="flex items-center justify-between gap-3 px-2">
        <div className="overflow-hidden">
          <AppLogo />
        </div>
      </div>

      <div className="mt-8 flex-1 space-y-6 overflow-y-auto pr-1">
        {navigationSections.map((section) => (
          <div key={section.title}>
            <p className="px-3 text-[11px] font-semibold uppercase tracking-[0.22em] text-muted-foreground/80">
              {section.title}
            </p>
            <div className="mt-2 space-y-1">
              {section.items.map((item) => {
                const Icon = item.icon;
                return (
                  <NavLink
                    key={item.path}
                    className={({ isActive }) =>
                      cn(
                        "group flex items-center gap-3 rounded-xl px-3 py-3 transition",
                        isActive
                          ? "bg-fiscal text-fiscal-foreground shadow-panel"
                          : "text-muted-foreground hover:bg-accent hover:text-foreground",
                      )
                    }
                    to={item.path}
                  >
                    <Icon className="size-5 shrink-0" />
                    <div className="min-w-0">
                      <div className="font-semibold">{item.title}</div>
                      <div className="mt-1 truncate text-xs opacity-75">
                        {item.description}
                      </div>
                    </div>
                  </NavLink>
                );
              })}
            </div>
          </div>
        ))}
      </div>


    </aside>
  );
}
